// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-item-color {
  color: #666565;
  white-space: normal;
  font-size: 14px;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.div-item {
  display: flex;
  width: 100%;
}

p {
  margin: 0 0 2px;
  letter-spacing: normal !important;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/suggest-station/suggest-station/suggest-station.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iDAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;AACF;;AACA;EACE,eAAA;EACA,iCAAA;EACA,eAAA;AAEF","sourcesContent":[".list-item-color {\n  color: #666565;\n  white-space: normal;\n  font-size: 14px;\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\n}\n\n.div-item {\n  display: flex;\n  width: 100%;\n}\np {\n  margin: 0 0 2px;\n  letter-spacing: normal !important;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
